import JacksonHeroSection from "./components/HeroSection";
import JacksonStickyNav from "./components/StickyNav";
import JacksonProcessingTimeSection from "./components/ProcessingTimeSection";
import JacksonFAQSection, { faqs } from "./components/FAQSection";
import CityServicesSection from "@/pages/city-template/components/CityServicesSection";
import CityLocalAreaSection from "@/pages/city-template/components/CityLocalAreaSection";
import CityTravelTimingSection from "@/pages/city-template/components/CityTravelTimingSection";
import CityDestinationsSection from "@/pages/city-template/components/CityDestinationsSection";
import CityTestimonialsSection from "@/pages/city-template/components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "@/pages/city-template/components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "@/pages/city-template/components/CityComparisonSection";
import CityMistakesSection from "@/pages/city-template/components/CityMistakesSection";
import CityHowItWorksSection from "@/pages/city-template/components/CityHowItWorksSection";
import CityHelpfulResourcesSection from "@/pages/city-template/components/CityHelpfulResourcesSection";
import CityFinalCTA from "@/pages/city-template/components/CityFinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import { jacksonConfig } from "./data";

const faqsMapped = faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }));
const servicesSchema = jacksonConfig.servicesSchema;

export default function JacksonPage() {
  const c = jacksonConfig;
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Jackson"
        state="Tennessee"
        stateAbbr="TN"
        route="/cities/jackson"
        title="Emergency Passport Jackson, TN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Jackson, TN — as fast as 24 hours. A+ BBB rated registered courier serving Union University, West Tennessee Healthcare, and all Madison County. No Nashville drive required."
        geoPlacename="Jackson, Tennessee"
        geoPosition="35.6145;-88.8139"
        faqs={faqsMapped}
        servicesSchema={servicesSchema}
        statePageName="Tennessee"
        statePageRoute="/states/tennessee"
      />
      <JacksonHeroSection />
      <JacksonStickyNav />
      <JacksonProcessingTimeSection />
      <CityServicesSection city={c.city} services={c.services} intro={c.servicesIntro} />
      <CityLocalAreaSection city={c.city} state={c.state} cities={c.nearbyCitiesZips} benefits={c.benefits} internalLinks={c.internalLinks} officeNote={c.fpcOfficeNote} officeDistance={c.fpcOfficeDistance} officeAddress={c.fpcOfficeAddress} serviceAreaIntro={c.serviceAreaIntro} nearbyCitiesIntro={c.nearbyCitiesIntro} />
      {c.travelTiming && <CityTravelTimingSection city={c.city} data={c.travelTiming} />}
      {c.destinations && <CityDestinationsSection city={c.city} data={c.destinations} />}
      <CityTestimonialsSection city={c.city} testimonials={c.testimonials} intro={c.testimonialsIntro} />
      <CityAcceptanceFacilitiesSection city={c.city} facilities={c.facilities} />
      <CityComparisonSection city={c.city} regionalAgency={c.regionalAgency} rows={c.comparisonRows} />
      <CityMistakesSection city={c.city} mistakes={c.mistakes} intro={c.mistakesIntro} />
      <CityHowItWorksSection city={c.city} steps={c.steps} intro={c.howItWorksIntro} />
      <JacksonFAQSection />
      <CityHelpfulResourcesSection city={c.city} state={c.state} photoLocations={c.photoLocations} dmvLocations={c.dmvLocations} airports={c.airports} dmvWebsite={c.dmvWebsite} dmvLabel={c.dmvLabel} />
      <SEOCrossLinks currentRoute="/cities/jackson" state="TN" />
      <CityFinalCTA />
    </div>
  );
}